import { StyleSheet, Text, View } from "react-native";
import * as Colors from "../../../../../styles/colors";
import * as Fonts from "../../../../../styles/typography";

export default function OptionPreference({ title, subtitle, children }) {
  return (
    <View style={styles.option}>
      <View style={styles.optionInfo}>
        <Text
          style={styles.optionTitle}
        >{title}</Text>
        <Text
          style={styles.optionSubtitle}
        >{subtitle}</Text>
      </View>
      <View>{children}</View>
    </View>
  );
}

const styles = StyleSheet.create({
  option: {
    backgroundColor: Colors.SNOW,
    flexDirection: "row",
    padding: 8,
    justifyContent: "space-between",
    alignItems: "center",
    shadowColor: Colors.GRAY_DARK,
    borderColor: Colors.SECONDARY,
    borderLeftWidth: 2,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    borderRadius: 8,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    marginBottom: 8,
  },
  optionTitle: {
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
  },
  optionSubtitle: {
    fontSize: Fonts.FONT_SIZE_14,
  },
  optionInfo: {
    justifyContent: "flex-start",
  },
});
